import React, { CSSProperties, forwardRef } from "react";
// import styled from "@emotion/styled";

// const FlexStyle = styled.div((props: {gap?: string, vertical?: string, wrap?: string, justify?: string, align?: string}) => ({
//   display: 'flex',
//   justifyContent: props.justify,
//   alignItems: props.align,
//   gap: props.gap
// }));

interface Props {
  children: React.ReactNode;
  vertical?: boolean;
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly' | 'start' | 'end' | 'left' | 'right' | 'normal' | 'stretch';
  align?: 'normal' | 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'first baseline' | 'last baseline' | 'start' | 'end' | 'self-start' | 'self-end' | 'safe center' | 'unsafe center' | 'inherit' | 'initial' | 'unset';
  gap?: string | number;
  style?: React.CSSProperties;
  className?: string;
}

const Flex = forwardRef<HTMLDivElement, Props>(({ children, style, gap, vertical = false, wrap, justify, align, className }, ref) => {
  const flexStyle: CSSProperties = {
    display: 'flex',
    flexDirection: vertical ? 'column' : undefined,
    flexWrap: wrap,
    justifyContent: justify,
    alignItems: align,
    gap,
    ...style,
  };

  return <div ref={ref} style={flexStyle} className={className}>{children}</div>;
});

Flex.displayName = 'Flex';

export default Flex;